import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { NumberField } from "@zfp-akademie-a-s/zfp-design/form/number-field";
import { AddIcon } from "@zfp-akademie-a-s/zfp-design/icons";
import { MinusIcon } from "Components/_Shared/Icons/Icons";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly value: number;
  readonly error?: boolean;
  readonly onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  readonly onIncrement: () => void;
  readonly onDecrement: () => void;
  readonly isIncrementDisabled: boolean;
  readonly isDecrementDisabled: boolean;
  readonly readOnly: boolean;
};

export const RecurringAmountInput: React.FC<Props> = ({
  value,
  error,
  onBlur,
  onIncrement,
  onDecrement,
  isDecrementDisabled,
  isIncrementDisabled,
  readOnly,
}) => {
  const theme = useTheme();
  const { t } = useResource();

  return (
    <Stack spacing={Spacing.L}>
      <Typography variant="body2" fontWeight={600}>
        {t(Resources.AnalysisDetail.Modeling.ResourcesToInvest)}
      </Typography>
      <Box display="flex">
        <IconButton
          disabled={isDecrementDisabled}
          sx={{ width: theme.spacing(10), marginRight: theme.spacing(Spacing.M) }}
          onClick={onDecrement}
        >
          <MinusIcon sx={{ color: "text.secondary" }} />
        </IconButton>
        <NumberField
          value={value}
          disabled={readOnly}
          name="allocatedAmount"
          onBlur={onBlur}
          error={error}
          min={0}
          thousandsSeparator=" "
          unit={t(Resources.Common.CZKSuffix)}
          slotProps={{ htmlInput: { "aria-label": t(Resources.AnalysisDetail.Modeling.ResourcesToInvest) } }}
        />
        <IconButton
          disabled={isIncrementDisabled}
          sx={{ width: theme.spacing(10), marginLeft: theme.spacing(Spacing.M) }}
          onClick={onIncrement}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};
